import { subscribeToPush } from "./subscribe";

async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  try {
    const registration = await navigator.serviceWorker.register("/service-worker.js");

    console.log("Service Worker registered", registration);

    const pushData = document.getElementById("pushData");
    // Only attempt if user is signed in
    if (pushData) {
      await subscribeToPush(registration);
    } else {
      console.log('User not signed in.');
    }
  } catch (e) {
    console.error("Service Worker registration failed", e);
  }

}

window.addEventListener("load", registerServiceWorker);